import React, { useEffect } from "react";
import { Switch, Route, Prompt, useHistory, useLocation, useParams } from "react-router-dom";
import EtimSelection from "./EtimSelection";
import EtimCharacteristics from "./EtimCharacteristics";
import EtimSummary from "./EtimSummary";
import { useEtim } from "../../context/ETIMContext";
import { useIntl } from "react-intl";

export default function EtimWizard(wizardProps) {
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();
  const { isDirty, etim, setEtim } = useEtim();
  const basePath = `/series/etim/edit/${etim.seriesId}`;
  function unsavedCheck(params) {
    return !isDirty || params.pathname.includes("/etim")
      ? true
      : intl.formatMessage({ id: "app.unsavedchanges", defaultMessage: "Are you sure you want to continue? You may lose any unsaved changes." });
  }

  return (
    <div className="product-creation-wizard">
      <Prompt message={unsavedCheck} />
      <Switch>
        <Route
          exact={true}
          path={`${basePath}`}
          render={(props) => {
            return <EtimSelection {...props} {...wizardProps} />;
          }}
        />
        <Route
          path={`${basePath}/:classEtim/characteristics`}
          render={(props) => {
            return <EtimCharacteristics {...props} {...wizardProps} />;
          }}
        />
        <Route
          path={`${basePath}/:classEtim/summary`}
          render={(props) => {
            return <EtimSummary {...props} {...wizardProps} />;
          }}
        />
        <Route
          exact
          path={`${basePath}`}
          render={() => {
            history.replace(`${basePath}`);
            return null;
          }}
        />
      </Switch>
    </div>
  );
}
